import React, { FC, type ReactNode, useContext } from 'react';
import { cn } from '../../utils/ui';
import { DropdownContext } from './DropdownContext';
/**
 * DropdownMenuItem Props Interface.
 */
export interface DropdownMenuItemProps {
    children: ReactNode;
    onClick?: () => void;
    className?: string;
}

/**
 * A dropdown item that acts as a button.
 * It automatically closes the dropdown on click.
 */
export const DropdownMenuItem: FC<DropdownMenuItemProps> = props => {
    const { children, onClick, className } = props;
    const context = useContext(DropdownContext);
    if (!context) throw new Error('DropdownMenuItem must be used within a DropdownMenu component.');

    const { setOpen } = context;

    const handleClick = () => {
        if (onClick) onClick();
        setOpen(false);
    };

    return (
        <div onClick={handleClick} className={cn('w-full transition', className)}>
            {children}
        </div>
    );
};
